<div class="page-wrap about-us">
    <div class="homeSlider">
        <div class="item">
        <img src="assets/images/slide1.jpg" alt="banner">
        </div>
    </div>
    <div class="container">
        <div class="row mb-5">
            <div class="col-12 col-md-12 col-lg-12">
                <div class="covers">
                    <h4 class="hdx"><span>About Us</span></h4>
                    <div class="page-content">
                        <p>
                            Co-WIN (Wining Over COVID-19) application has been developed as a comprehensive cloud-based IT solution for planning, implementation & monitoring of COVID-19 vaccination in India. The Co-WIN system is an end to end solution that has utilities for the entire public health system from national level up to the vaccinator level. Co-WIN system on a real time basis will track not only the beneficiaries but also the vaccines, at national, state and district level.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
